// The contract a slide reads from the slideshow it sits in.  It exists as its
// own file, and as an abstract class rather than an InjectionToken, so
// slide.component.ts can name the token without importing
// slideshow.component.ts: a circular import between the two would leave the
// token undefined at the moment the slide's constructor is decorated.
export abstract class SlideshowHost {

  abstract cover:boolean;

  abstract backgroundPosition:string;

  abstract width:number;

  abstract height:number;

  abstract hasIntrinsicRatio:boolean;

  // Slides announce themselves from their constructor, which runs while the
  // view is created - before any binding is evaluated - so the first render
  // already knows which slide is the active one.  A @ContentChildren query
  // would only resolve after those bindings had run.
  abstract register(slide:object):void;

  abstract unregister(slide:object):void;

  // Identity comparisons rather than an index handed to the slide: the slide
  // only ever reads, so nothing is written into an already-checked view.
  abstract isActive(slide:object):boolean;

  abstract isFirst(slide:object):boolean;

}
